import type { Translations } from "~contexts/I18nContext/I18nContext.tsx";
import { AbsenceCategory, TrackingTaskType } from "~generated";

export function absenceCategoryForTrackingTaskType(
  trackingTaskType: TrackingTaskType,
): AbsenceCategory {
  switch (trackingTaskType) {
    case TrackingTaskType.SICKNESS:
      return AbsenceCategory.SICKNESS;
    case TrackingTaskType.VACATION:
      return AbsenceCategory.VACATION;
    case TrackingTaskType.SCHOOL:
      return AbsenceCategory.SCHOOL;
    case TrackingTaskType.TRAINING:
      return AbsenceCategory.TRAINING;
    case TrackingTaskType.LEISURE_TIME_ACCOUNT:
      return AbsenceCategory.LEISURE_TIME_ACCOUNT;
    default:
      throw new Error(
        `${trackingTaskType} can't be mapped to an absence category`,
      );
  }
}

export function isAbsenceType(trackingTaskType?: TrackingTaskType | null) {
  if (!trackingTaskType) {
    return false;
  }
  return [
    TrackingTaskType.SICKNESS,
    TrackingTaskType.VACATION,
    TrackingTaskType.SCHOOL,
    TrackingTaskType.TRAINING,
    TrackingTaskType.LEISURE_TIME_ACCOUNT,
  ].includes(trackingTaskType);
}

export function isWorkType(trackingTaskType?: TrackingTaskType | null) {
  return trackingTaskType === TrackingTaskType.WORK;
}

export function getLabelForTrackingTaskType(
  t: Translations,
  trackingTaskType?: TrackingTaskType | null,
  workPackageId?: string | null,
) {
  if (!trackingTaskType) {
    return t.unknown;
  }
  if (isAbsenceType(trackingTaskType)) {
    return t.timeEntryHistoryAbsenceLabel;
  }
  if (isWorkType(trackingTaskType)) {
    if (workPackageId) {
      return t.timeEntryHistoryWorkPackageLabel;
    }
    return t.timeEntryHistoryManagerLabel;
  }
  return t.timeEntryHistoryGenericTaskLabel;
}
